<template>
  <div id="home">

    <div id="home-main">

      <grid-hero />
      <grid-about />
      <grid-project-image />

      <div id="home-sidebar">

        <sidebar-project
          v-for="(project, i) in homepageProjects"
          :key="i"
          :project="project"
          :title="project.title"
          :year="project.year"
          :client="project.client"
          :type="project.type"
          :color="project.color"
          :slug="project.slug"/>

        <router-link
          class="sidebar-project see-all"
          to="projects"
          tag="div">

          <div class="sidebar-project-info">
            <h3>See All Projects</h3>
            <p>Visit the work page</p>
          </div>

          <div class="sidebar-project-image"
          :style="{backgroundImage: 'url(img/city.jpg)'}" />

          <div class="sidebar-project-arrow">
            <svg width="25" height="19" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path :style="{stroke: '#616E7C'}" d="M1 9.5H24M24 9.5L15.701 2M24 9.5L15.701 17" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
          </div>

        </router-link>

      </div>

    </div>

    <vue-headful title="Dan Araujo | Home"/>
    <div id="preload">
      <img
      v-for="(projectR, pRi) in homepageProjects"
      :key="`pRi${pRi}`"
      :src="`/img/renders/${projectR.slug}.png`"/>

      <img
      v-for="(projectT, pTi) in homepageProjects"
      :key="`pTi${pTi}`"
      :src="`/img/thumbs/${projectT.slug}.jpg`"/>
    </div>
  </div>
</template>

<script>
import projects from '../assets/projects.json'
import SidebarProject from '../components/home/SidebarProject.vue'
import GridProjectImage from '../components/home/GridProjectImage.vue'
import GridHero from '../components/home/GridHero.vue'
import GridAbout from '../components/home/GridAbout.vue'
import anime from 'animejs'

export default {

  components: { SidebarProject, GridProjectImage, GridHero, GridAbout },

  data () {
    return {
      homepageProjects: [],
      sidebarProjectElements: [],
      maxProjects: 6,
      timeOut: 200,
      projectTimer: 6000,
      currentProjectIndex: 0
    }
  },
  methods: {
    animateNewProj () {
      anime.remove('#render-img')
      anime.remove('#project-image')
      anime.remove('.banner-content')
      anime.remove('.line')

      let renderImgTL = anime.timeline({})
      renderImgTL
        .add({
          targets: '#render-img',
          translateX: [0, '100%'],
          opacity: [1, 0],
          easing: 'easeInCirc',
          duration: this.timeOut
        })
        .add({
          targets: '#render-img',
          translateX: ['-100%', 0],
          opacity: [0, 1],
          easing: 'easeOutCirc',
          duration: this.timeOut * 2
        })

      let projectImageTL = anime.timeline({})
      projectImageTL
        .add({
          targets: '#project-image',
          scale: [1, 1.5],
          easing: 'easeInCirc',
          duration: this.timeOut
        })
        .add({
          targets: '#project-image',
          scale: [1.75, 1],
          easing: 'easeOutCirc',
          duration: this.timeOut * 5
        })

      let projectBannerTL = anime.timeline({})
      projectBannerTL
        .add({
          targets: '.banner-content',
          opacity: [1, 0],
          scale: [1, 1.1],
          easing: 'easeInQuad',
          duration: this.timeOut
        })
        .add({
          targets: '.banner-content',
          opacity: [0, 1],
          scale: [0.75, 1],
          easing: 'easeOutQuad',
          duration: this.timeOut * 2
        })

      let lineTL = anime.timeline({})
      lineTL
        .add({
          targets: '.line',
          scaleX: [1, 0],
          easing: 'easeInQuad',
          duration: this.timeOut
        })
        .add({
          targets: '.line',
          scaleX: [0, 1],
          easing: 'easeOutElastic',
          duration: this.timeOut * 4
        })
    },
    activateProject (i, delay) {
      this.animateNewProj()
  
      setTimeout(() => {
        this.$store.state.activeProject = this.homepageProjects[i]
        console.log(this.$store.state.activeProject)
        this.currentProjectIndex = i
      }, delay)

      this.sidebarProjectElements.forEach((el) => {
        el.classList.remove('sidebar-project-active')
      })

      this.sidebarProjectElements[i].classList.add('sidebar-project-active')
    }
  },
  beforeMount () {
    let i = 0
    let self = this

    Object.entries(projects).forEach(([key, project]) => {
      if (i < this.maxProjects) {
        self.homepageProjects.push(project)
      }

      i++
    })

    this.$store.state.activeProject = this.homepageProjects[0]
  },
  beforeRouteLeave(to, from, next) {
    this.$store.state.sidebarLoopDead = true
    next()
  },
  mounted () {
    let self = this
    clearInterval(projectLoop);

    anime({
      targets: '.sidebar-project',
      translateX: ['100%', 0],
      opacity: [0, 1],
      easing: 'easeOutCirc',
      delay: anime.stagger(100, { from: 'center', start: 100 })
    })

    this.sidebarProjectElements = document.querySelectorAll('.sidebar-project')
    this.sidebarProjectElements[0].classList.add('sidebar-project-active')

    this.sidebarProjectElements.forEach((el, i) => {
      el.addEventListener('click', function () {
        self.$store.state.sidebarLoopDead = true
        clearInterval(projectLoop);

        if (!el.classList.contains('sidebar-project-active')) {
          self.activateProject(i, self.timeOut)
        }
      })
    })

    let projectLoop = setInterval(() => {
      if ((!this.$store.state.sidebarLoopDead) && (this.$route.name === 'home')) {
        this.currentProjectIndex < this.maxProjects - 1 ? this.activateProject(this.currentProjectIndex + 1, this.timeOut) : this.activateProject(0, this.timeOut)
      }
    }, this.projectTimer)

    let projectSection = document.querySelector('#home-sidebar')

    let handleResize = () => {
      window.innerWidth < 900 ? projectSection.style.width = `${window.innerWidth - 50}px` : projectSection.style.width = 'auto'
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    this.activateProject(0, 0)
  }
}

</script>

<style lang="scss" scoped>

  #home {
    display: block;
    width: 100vw;
    height: 100vh;
    padding: $grid-gap;
    box-sizing: border-box;
    @extend %container;

    @include tablet-below {
      height: auto;
    }
  }

  #home-sidebar {
    grid-area: sidebar;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    animation: fadeShadow;
    animation-duration: 3s;
    animation-fill-mode: forwards;

    @include tablet-below {
      margin: $grid-gap 0;
      flex-direction: row;
      width: 360px;
      height: 150px;
      overflow-x: scroll;
      overflow-y: hidden;
      order: 2;
    }
  }

  @keyframes fadeShadow {
    from {box-shadow: none;}
    to {box-shadow: $standard-shadow}
  }

  #home-main {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: [hero-start image-start] 25% [image-end about-start] 50% [hero-end about-end sidebar-start] 1fr [sidebar-end];
    grid-template-rows: [hero-start sidebar-start] 3fr [hero-end about-start image-start] 2fr [about-end image-end sidebar-end];
    grid-gap: $grid-gap;
    
    @include tablet-below {
      width: 100%;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
    }
  }

  #preload {display: none; position: absolute; left: 1000%;}

</style>
